import React from "react";

import {
  Box,
  BoxProps,
  Flex,
  IconCircularArrow,
  IconMobile,
  IconShield,
  Link,
  Span,
} from "@catchoftheday/cg-components";

import { Container } from "../../components/Container";
import {
  HeaderConfiguration,
  TopHeaderLink,
  TopHeaderLinks,
} from "../../types/index";

const topHeaderLinks: TopHeaderLinks = {
  leftSection: [
    {
      name: "Catch Mobile",
      url: "https://www.catch.com.au/event/catch-connect-mobile-phone-plans-88137",
      icon: "mobile",
    },
  ],
  rightSection: [
    {
      name: "Careers",
      icon: "",
      url: "https://www.catch.com.au/careers",
    },
    {
      name: "Gift Cards",
      icon: "",
      url: "https://www.catch.com.au/gift-card",
    },
    {
      name: "Help",
      icon: "",
      url: "https://help.catch.com.au/hc/en-us",
    },
  ],
};

export type TopHeaderProps = {
  isLoggedIn?: boolean;
  headerConfiguration?: HeaderConfiguration;
} & BoxProps;

function matchIcon(name: string) {
  let Component: typeof IconMobile | undefined;

  switch (name) {
    case "mobile": {
      Component = IconMobile;
      break;
    }
    case "shield": {
      Component = IconShield;
      break;
    }
    case "circularArrow": {
      Component = IconCircularArrow;
      break;
    }
    default:
      Component = undefined;
      break;
  }

  return Component;
}

export const TopHeader: React.FC<TopHeaderProps> = ({
  isLoggedIn,
  headerConfiguration,
  ...props
}) => {
  function renderHeaderLink(
    { name, url, icon, iconSize }: TopHeaderLink,
    { marginRight = "0", marginLeft = "0" }
  ) {
    const Icon = icon ? matchIcon(icon) : null;

    return (
      <Link
        href={url}
        key={name}
        ml={marginLeft}
        mr={marginRight}
        color="typography.subText"
      >
        {Icon && (
          <Icon
            data-testid={`icon-${icon}`}
            mr=".175rem"
            color={"typography.inactive"}
            width={iconSize || 15}
            height={iconSize || 15}
            aria-hidden="true"
          />
        )}
        <Span verticalAlign="middle" fontWeight="normal" fontSize={"xs"}>
          {name}
        </Span>
      </Link>
    );
  }

  function loggedInLinks() {
    return [
      {
        name: "Track My Order",
        icon: "",
        url: isLoggedIn
          ? "/my-account/my-orders"
          : "https://help.catch.com.au/hc/en-us",
      },
    ];
  }

  const leftSection = headerConfiguration
    ? headerConfiguration.topHeader.leftSection
    : topHeaderLinks.leftSection;

  const rightSection = headerConfiguration
    ? headerConfiguration.topHeader.rightSection
    : topHeaderLinks.rightSection;

  const statefulLinks = headerConfiguration ? [] : loggedInLinks();

  return (
    <Box as="nav" aria-label="Top Header Navigation">
      <Container backgroundColor="ui.backgroundColor" {...props}>
        <Flex py="0.175rem">
          <Flex justifyContent="flex-start" alignItems="baseline" flexGrow={1}>
            {leftSection.map((section) =>
              renderHeaderLink(section, { marginRight: "1.3125rem" })
            )}
          </Flex>
          <Flex justifyContent="flex-end" alignItems="baseline" flexGrow={1}>
            {rightSection.map((section) =>
              renderHeaderLink(section, { marginLeft: "1.75rem" })
            )}
            {statefulLinks.map((section) =>
              renderHeaderLink(section, { marginLeft: "1.75rem" })
            )}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
